require('./suivie-authent.scss');

import DemandeActions from '../../../../actions/demande.actions';
import {
  STEPS
} from '../../../../utils/routes.util';
import deburr from 'lodash/deburr';

export default class SuivieAuthentComponent {
  constructor() {
    this.controller = SuivieAuthentController;
    this.template = require('./suivie-authent.html');
  }
}

// @ngInject
class SuivieAuthentController {

  constructor($scope, $ngRedux) {
    this.data = {};
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.regex = new RegExp(/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/, 'u');
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.SUIVIE_AUTHENT));
    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching
        };
      }
    )(this);
    this.data.identifiant = 'VGS_';
    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }

  // Actions

  nextStep() {
    //enlever les accents
    this.data.nom = deburr(this.data.nom);
    this.data.prenom = deburr(this.data.prenom);
    this.$ngRedux.dispatch(DemandeActions.updateSuivieAuthent(this.data));
  }

  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updateSuivieAuthent(this.data, true));
  }
}



// WEBPACK FOOTER //
// ./src/modules/suivie-dossier/components/suivie-authent/suivie-authent.component.js